export default __webpack_public_path__ + "static/decluttering an attic-e153d3f080fb23099b82e2094687f6d4.png";